import { authService } from '@innovamat/radiance-utils';
import { CLIENT_ID, ENVIRONMENT } from '../utils/variables';

export function authServiceInit(apiUsers: string): void {
  authService.init(apiUsers, CLIENT_ID, ENVIRONMENT);
}
